import { Component, OnInit, HostListener } from '@angular/core';
declare var $: any;
declare var jquery: any;
import { GridApi, GridOptions, GridReadyEvent } from "ag-grid/main";
import { AdminService, AssessmentPurchaseDto, AdminPurchaseDto, AdminAssessmentPurchaseDto, RaterTypeDto } from 'app/services/admin/AdminService';
import { CoachService } from 'app/services/coach/CoachService';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'app/globals';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-duplicate-users',
  templateUrl: './duplicate-users.component.html',
  styleUrls: ['./duplicate-users.component.css']
})
export class DuplicateUsersComponent implements OnInit {

    data: string[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    rowSelection: string;

    currentRowIndex: number;
    action: string;
    name: string = '';
    min: number = 3;
    currentRaterId: number;
    loading: boolean = false;

    constructor
        (
            private _AdminService: AdminService,
            private _Globals: Globals,
        ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "multiple";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

        this.getDuplicateUsers();
    }

    private getDuplicateUsers() {
        this.loading = true;
        this._AdminService.getDuplicateUsers().subscribe((response: { result: { Result: number, Data: string } }) => {
            console.log('response_GetGlobalRaterTypes', response);
            this.loading = false;

            if (this._Globals.validationToken(response.result.Result)) {
                this.data = JSON.parse(response.result.Data).duplicateUsers;
                console.log('this.data', this.data);
            }
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Email',
            field: 'Email',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: (params) => {
                return `<div style="overflow:hidden !important;text-overflow:ellipsis;">` + params.value + `</div>`;
            }
        };
        columnDefs.push(nameHeader);     

        return columnDefs;
    }

    public downloadAsCSV() {
        this.exportToCsv(`DuplicateUsers.csv`, this.gridApi);
    }

    private exportToCsv(file_name: string, gridApi) {
        var params = this.geParams(file_name);
        if (params.suppressQuotes || params.columnSeparator) {
            console.log(
                `NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel.`
            );
        }
        gridApi.exportDataAsCsv(params);
    }

    private geParams(file_name) {
        return {
            suppressQuotes: false,
            columnSeparator: `,`,
            customHeader: false,
            customFooter: false,
            fileName: file_name
        };
    }
}

